import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

interface IconExtProps extends IconProps {
  dark?: boolean;
}
export const InfoIcon: React.FC<IconExtProps> = (props) => {
  return (
    <Icon w="17px" h="16px" viewBox="0 0 17 16" {...props}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1659_14134)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58173 12.9183 0 8.5 0C4.08173 0 0.5 3.58173 0.5 8C0.5 12.4183 4.08173 16 8.5 16ZM8.5 4.71429C7.86882 4.71429 7.35714 5.22597 7.35714 5.85714C7.35714 6.33053 6.97338 6.71429 6.5 6.71429C6.02662 6.71429 5.64286 6.33053 5.64286 5.85714C5.64286 4.27919 6.92205 3 8.5 3C10.078 3 11.3571 4.27919 11.3571 5.85714C11.3571 7.13647 10.5163 8.21941 9.35714 8.58349V8.71429C9.35714 9.18767 8.97338 9.57143 8.5 9.57143C8.02662 9.57143 7.64286 9.18767 7.64286 8.71429V7.85714C7.64286 7.38376 8.02662 7 8.5 7C9.13118 7 9.64286 6.48832 9.64286 5.85714C9.64286 5.22597 9.13118 4.71429 8.5 4.71429ZM8.5 10.7143C9.13118 10.7143 9.64286 11.226 9.64286 11.8571C9.64286 12.4883 9.13118 13 8.5 13C7.86882 13 7.35714 12.4883 7.35714 11.8571C7.35714 11.226 7.86882 10.7143 8.5 10.7143Z"
            fill="#5F738C"
          />
        </g>
        <defs>
          <clipPath id="clip0_1659_14134">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
